import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ves-cashin-form',
  templateUrl: './ves-cashin-form.component.html',
  styleUrl: '../../add-cashin.component.scss',
  // Mantiene la fila del formulario como hija visual directa del layout padre.
  styles: [':host { display: contents; }'],
})
export class VesCashinFormComponent {
  @Input() ctx!: any;
}
